import React from "react";
import { State } from "../../state/state";
import { AchievementInfo } from "../../state/Achievements/AchievementInfoTypes";
import "./AchievementCard.css";

interface AchievementCardProps {
  state: State;
  achievement: AchievementInfo;
}

const AchievementCard: React.FC<AchievementCardProps> = ({
  state,
  achievement,
}) => {
  const isUnlocked = state.unlockedAchievements.has(achievement.id);

  // Calculate current progress for this achievement
  const getCurrentProgress = (): number => {
    switch (achievement.category) {
      case "total":
        if (achievement.id.includes("total_bricks")) {
          return state.totalBricksCollected;
        }
        if (achievement.id.includes("total_actions")) {
          return state.totalActionsTriggered;
        }
        if (achievement.id.includes("total_sets")) {
          return state.totalSetsPurchased;
        }
        return 0;

      case "brick":
        return state.bricksCollectedByType.get(achievement.targetId || "") || 0;

      case "action":
        return (
          state.actionsTriggeredByType.get(achievement.targetId || "") || 0
        );

      case "brickpack":
        return state.brickPackStats.get(achievement.targetId || "") || 0;

      case "set":
        return state.setsPurchasedByType.get(achievement.targetId || "") || 0;

      default:
        return 0;
    }
  };

  const currentProgress = getCurrentProgress();
  const progressPercentage = Math.min(
    (currentProgress / achievement.threshold) * 100,
    100,
  );

  return (
    <div
      className={`achievementCard ${isUnlocked ? "achievementUnlocked" : "achievementLocked"}`}
    >
      <div className="achievementCardHeader">
        <div className="achievementTitle">{achievement.title}</div>
        <div
          className={`achievementStatus ${isUnlocked ? "statusUnlocked" : "statusLocked"}`}
        >
          {isUnlocked ? "Unlocked" : "Locked"}
        </div>
      </div>
      <div className="achievementDescription">{achievement.description}</div>
      {!isUnlocked && (
        <div className="achievementProgress">
          <div className="achievementProgressBar">
            <div
              className="achievementProgressFill"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
          <div className="achievementProgressText">
            {currentProgress} / {achievement.threshold} (
            {progressPercentage.toFixed(0)}%)
          </div>
        </div>
      )}
    </div>
  );
};

export default AchievementCard;
